import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  default: {
    firm: null,
    calibrate: null,
    calibrateType: null,
    contact: null,
    fleetNumber: '',
    insurance: null,
    fleetContact: null,
    notes: '',
    ronumber: '',
    vehicle: {
      vehicle: null,
      firm: null,
      contact: null,
      year: '2020',
      make: null,
      model: '',
      vin: ''
    },
    estimator: null,
    createdBy: null,
    status: 1
  },
  defaultEvent: {
    calibrateEvent: null,
    firm: null,
    firmName: null,
    ronumber: null,
    createdBy: null,
    calibrate: null,
    calibrateEventType: null,
    calibrateStatusType: null,
    scheduled: null,
    bay: null,
    started: null,
    completed: null,
    notes: '',
    results: '',
    techIds: null,
    calibrateReadyIds: null,
    transportationTypeIds: null,
    calibratePrecheckIds: null,
    calibrateServiceIds: null,
    calibrateActionIds: null,
    calibrateVerifyIds: null,
    state: null,
    skipReady: false,
    skipPrecheck: false,
    skipActions: false,
    serviceList: [],
    readyList: [],
    precheckList: [],
    actionList: [],
    verifyList: [],
    paymentType: null,
    paymentTypeName: null,
    techSelected: false
  },
  pageSize: storage.local.getItem(types.CALIBRATE_PAGE_SIZE) || 10,
  searchTerm: storage.session.getItem(types.CALIBRATE_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.CALIBRATE_SORT_DIR) || 'desc',
  orderBy: storage.session.getItem(types.CALIBRATE_ORDER_BY) || 'lastEventDate',
  filterBy: parseInt(storage.local.getItem(types.CALIBRATE_FILTER_BY)) || null,
  filterOptions: [],
  calibrates: [],
  calibrate: null,
  calibrateEvents: [],
  calibrateEvent: null,
  calibrateEventCurrent: null,
  highlightSave: false,
  isCalibrateChecked: false,
  calibrateServiceRates: [],
  repairlines: [],
  calibrateCounts: {
    pending: null,
    completed: null,
    inProcess: null,
    scheduled: null
  },
  isChange: false,
  isCalibrateEventDialog: false,
  requestServices: []
})



// WEBPACK FOOTER //
// ./src/store/modules/calibrates/state.js